import React, { FC } from 'react';
import { Box, Divider, Heading } from '@wix/design-system';
import { ChevronLeftLarge } from '@wix/wix-ui-icons-common';
import { useTemplateContext } from '@components/Contexts/TemplateContext';
import PurchaseCTAs from '../PurchaseCTAs';
import s from './ContentStickyHeader.module.scss';
import { TEMPLATES_GALLERY_ENTRY } from '@utils/constants';
import { useTemplateEntry } from '@components/Hooks/useTemplateEntry';

interface ContentStickyHeaderProps {
  setPurchaseError: (isError: boolean) => void;
}

const ContentStickyHeader: FC<ContentStickyHeaderProps> = ({
  setPurchaseError,
}) => {
  const { showStickyCTAs, template } = useTemplateContext();
  const { entry } = useTemplateEntry();

  if (showStickyCTAs) {
    return (
      <div className={s.templateStickyHeader} style={{ width: '100vw' }}>
        <Box
          margin={'0 auto'}
          maxWidth="1280px"
          minWidth="926px"
          width={'100%'}
          height={'96px'}
        >
          <Box padding={'0 0 0 48px'} width={'100%'} verticalAlign="middle">
            <Box direction="vertical" width={'100%'}>
              <Box verticalAlign="middle" gap="12px" display={'flex'}>
                {entry === TEMPLATES_GALLERY_ENTRY && (
                  <ChevronLeftLarge
                    cursor="pointer"
                    color="#000624"
                    onClick={() => {
                      window.history.back();
                    }}
                  />
                )}
                <Heading size="medium" as="h3">
                  {template.title}
                </Heading>
              </Box>
            </Box>
            <Box
              verticalAlign="middle"
              padding="4px 48px 0 24px"
              display={'flex'}
            >
              <PurchaseCTAs
                purchaseCtaOnTheRight={true}
                buttonSize="medium"
                isMobileView={false}
                setPurchaseError={setPurchaseError}
              />
            </Box>
          </Box>
        </Box>
        <Box padding={'0'} marginTop={'2px'}>
          <Divider />
        </Box>
      </div>
    );
  }

  return <></>;
};

export default ContentStickyHeader;
